module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-rahmen-01.bb25a45f.jpeg";